import { adaptV4Theme, createTheme } from '@mui/material/styles';
import React from 'react';

import COLORS from './colors';
import { CheckedIcon, IndeterminateIcon, RadioCheckedIcon, RadioUncheckedIcon, UncheckedIcon } from './icons';
import { fossaPrimaryFont } from './typography';

/**
 * Material UI Theme
 */
export const styles = {
  typography: {
    fontFamily: fossaPrimaryFont,
  },
  palette: {
    primary: {
      main: COLORS.fossaGreen,
    },
    secondary: {
      main: COLORS.fossaSlateBlue,
    },
    text: {
      primary: COLORS.fossaMidnightBlue,
    },
  },
  overrides: {
    MuiButton: {
      text: {
        fontSize: '1rem',
      },
    },
    // Backup custom colors for Checkbox and Radio in case css module is not used
    MuiCheckbox: {
      root: {
        color: COLORS.fossaGray60,
        '&:hover': {
          color: COLORS.fossaGray80,
        },

        '&.Mui-checked': {
          color: COLORS.fossaGreen,
          '&:hover': {
            color: COLORS.fossaGreen110,
          },
        },
      },
    },
    MuiRadio: {
      root: {
        color: COLORS.fossaGray60,
        '& svg': {
          width: '16px',
          height: '16px',
        },
        '&.Mui-checked': {
          color: COLORS.fossaGreen,
          '&:hover': {
            color: COLORS.fossaGreen110,
          },
        },
      },
    },
    MuiFormControlLabel: {
      root: {
        marginLeft: 0,
        marginRight: 0,
        marginBottom: '8px',
      },
      label: {
        fontFamily: fossaPrimaryFont,
        fontSize: '12px',
        fontWeight: 500,
        color: COLORS.textColorSecondary,
      },
    },
  },
  props: {
    MuiCheckbox: {
      icon: React.createElement(UncheckedIcon),
      checkedIcon: React.createElement(CheckedIcon),
      indeterminateIcon: React.createElement(IndeterminateIcon),
    },
    MuiRadio: {
      icon: React.createElement(RadioUncheckedIcon),
      checkedIcon: React.createElement(RadioCheckedIcon),
    },
  },
  raisedButton: {
    primaryColor: COLORS.fossaGreen,
    disabledColor: COLORS.fossaGray20,
  },
  flatButton: {
    primaryTextColor: COLORS.fossaGreen,
    disabledColor: COLORS.fossaGray20,
    fontWeight: 700,
  },
  statuses: {
    error: COLORS.fossaRed,
    success: COLORS.fossaGreen,
    warning: COLORS.fossaYellow,
    disabled: COLORS.fossaGray20,
  },
  backgrounds: {
    light: COLORS.fossaGray05,
    dark: COLORS.fossaSlateBlue,
  },
  spacing: 15, // Grid size
};

export const theme = createTheme(adaptV4Theme(styles));
